<template>
    <Form @submit="submit" :validation-schema="getSchema()">
        <div class="flex items-center  xl:flex-row flex-col gap-3 mt-3 mb-3">
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper">
                    <Field v-slot="{field, errors, errorMessage}" name="variantName" v-model="form.variantName">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Variant Name</label>
                        <input v-bind="field" placeholder="3.5g" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="text">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>

            <div class="w-full xl:w-1/3">
                <div class="input-wrapper">
                    <Field v-slot="{field, errors, errorMessage}" name="dryCannabisEquivalency" v-model="form.dryCannabisEquivalency">
                        <label class="text-xs">Cart Equivalency</label>
                        <div v-if="productForm.complianceType && productForm.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                        <input v-else v-bind="field" placeholder="1-4" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="text">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
            <div class="w-full xl:w-1/3" v-if="vg_selectedLocation.id">
                <div class="input-wrapper">
                    <Field type="checkbox" v-slot="{field}" name="thc_cbd_value_type" v-model="form.thc_cbd_value_type" value="range" unchecked-value="single">
                        <span class="text-white text-xs font-normal"> THC/CBD Values </span>
                        <label for="item-range" class="flex items-center cursor-pointer  w-[160px]">
                            <span class="mr-2 text-white text-sm tracking-wider"> Single </span>
                            <input v-bind="field" value="range" type="checkbox" id="item-range" class="hidden peer">
                            <div class="w-12 bg-theme-green h-6 peer-focus:outline-none peer-focus:ring-4 
                            peer-focus:ring-theme-green dark:peer-focus:ring-theme-green relative rounded-full peer 
                            dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] 
                            after:absolute  after:bg-white after:border-gray-400 after:border after:rounded-full 
                            after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-gray-400"></div>
                            <span class="ml-2 text-white text-sm text-theme-878686 tracking-wider"> Range </span>
                        </label>
                    </Field>
                </div>
            </div>
        </div>
        <div class="flex gap-3 xl:flex-row flex-col items-start mb-3" v-if="vg_selectedLocation.id">
            <div class="w-full xl:w-1/4">
                <div class="input-wrapper relative">
                    <Field v-slot="{field, errors, errorMessage}" name="cost" v-model="form.cost">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Cost</label>
                        <span class="absolute top-[33px] left-3">
                            <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.88281 0.820312V3.125H3.66406V0.820312H4.88281ZM4.73438 13.5781V15.6797H3.51562V13.5781H4.73438ZM5.59375 11.0156C5.59375 10.7188 5.53906 10.4661 5.42969 10.2578C5.32552 10.0495 5.15365 9.86458 4.91406 9.70312C4.67969 9.54167 4.36198 9.38542 3.96094 9.23438C3.28385 8.97396 2.6875 8.69792 2.17188 8.40625C1.66146 8.10938 1.26302 7.74219 0.976562 7.30469C0.690104 6.86198 0.546875 6.30208 0.546875 5.625C0.546875 4.97917 0.700521 4.41927 1.00781 3.94531C1.3151 3.47135 1.73958 3.10677 2.28125 2.85156C2.82812 2.59115 3.46354 2.46094 4.1875 2.46094C4.73958 2.46094 5.23958 2.54427 5.6875 2.71094C6.13542 2.8724 6.52083 3.11198 6.84375 3.42969C7.16667 3.74219 7.41406 4.125 7.58594 4.57812C7.75781 5.03125 7.84375 5.54948 7.84375 6.13281H5.60156C5.60156 5.82031 5.56771 5.54427 5.5 5.30469C5.43229 5.0651 5.33333 4.86458 5.20312 4.70312C5.07812 4.54167 4.92708 4.42188 4.75 4.34375C4.57292 4.26042 4.3776 4.21875 4.16406 4.21875C3.84635 4.21875 3.58594 4.28125 3.38281 4.40625C3.17969 4.53125 3.03125 4.70052 2.9375 4.91406C2.84896 5.1224 2.80469 5.36198 2.80469 5.63281C2.80469 5.89844 2.85156 6.13021 2.94531 6.32812C3.04427 6.52604 3.21354 6.70833 3.45312 6.875C3.69271 7.03646 4.02083 7.20312 4.4375 7.375C5.11458 7.63542 5.70833 7.91667 6.21875 8.21875C6.72917 8.52083 7.1276 8.89062 7.41406 9.32812C7.70052 9.76562 7.84375 10.3229 7.84375 11C7.84375 11.6719 7.6875 12.2448 7.375 12.7188C7.0625 13.1875 6.625 13.5469 6.0625 13.7969C5.5 14.0417 4.84896 14.1641 4.10938 14.1641C3.63021 14.1641 3.15365 14.1016 2.67969 13.9766C2.20573 13.8464 1.77604 13.638 1.39062 13.3516C1.00521 13.0651 0.697917 12.6849 0.46875 12.2109C0.239583 11.7318 0.125 11.1432 0.125 10.4453H2.375C2.375 10.8255 2.42448 11.1432 2.52344 11.3984C2.6224 11.6484 2.7526 11.849 2.91406 12C3.08073 12.1458 3.26823 12.25 3.47656 12.3125C3.6849 12.375 3.89583 12.4062 4.10938 12.4062C4.44271 12.4062 4.71615 12.3464 4.92969 12.2266C5.14844 12.1068 5.3125 11.9427 5.42188 11.7344C5.53646 11.5208 5.59375 11.2812 5.59375 11.0156Z" fill="white"/>
                            </svg>
                        </span>
                        <input @wheel.prevent v-model="form.cost" placeholder="39.99" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686 pl-6" type="number">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
           
            <div class="w-full xl:w-1/4">
                <div class="input-wrapper relative">
                    <Field v-slot="{field, errors, errorMessage}" name="price" v-model="form.price">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Regular Price</label>
                        <span class="absolute top-[33px] left-3">
                            <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.88281 0.820312V3.125H3.66406V0.820312H4.88281ZM4.73438 13.5781V15.6797H3.51562V13.5781H4.73438ZM5.59375 11.0156C5.59375 10.7188 5.53906 10.4661 5.42969 10.2578C5.32552 10.0495 5.15365 9.86458 4.91406 9.70312C4.67969 9.54167 4.36198 9.38542 3.96094 9.23438C3.28385 8.97396 2.6875 8.69792 2.17188 8.40625C1.66146 8.10938 1.26302 7.74219 0.976562 7.30469C0.690104 6.86198 0.546875 6.30208 0.546875 5.625C0.546875 4.97917 0.700521 4.41927 1.00781 3.94531C1.3151 3.47135 1.73958 3.10677 2.28125 2.85156C2.82812 2.59115 3.46354 2.46094 4.1875 2.46094C4.73958 2.46094 5.23958 2.54427 5.6875 2.71094C6.13542 2.8724 6.52083 3.11198 6.84375 3.42969C7.16667 3.74219 7.41406 4.125 7.58594 4.57812C7.75781 5.03125 7.84375 5.54948 7.84375 6.13281H5.60156C5.60156 5.82031 5.56771 5.54427 5.5 5.30469C5.43229 5.0651 5.33333 4.86458 5.20312 4.70312C5.07812 4.54167 4.92708 4.42188 4.75 4.34375C4.57292 4.26042 4.3776 4.21875 4.16406 4.21875C3.84635 4.21875 3.58594 4.28125 3.38281 4.40625C3.17969 4.53125 3.03125 4.70052 2.9375 4.91406C2.84896 5.1224 2.80469 5.36198 2.80469 5.63281C2.80469 5.89844 2.85156 6.13021 2.94531 6.32812C3.04427 6.52604 3.21354 6.70833 3.45312 6.875C3.69271 7.03646 4.02083 7.20312 4.4375 7.375C5.11458 7.63542 5.70833 7.91667 6.21875 8.21875C6.72917 8.52083 7.1276 8.89062 7.41406 9.32812C7.70052 9.76562 7.84375 10.3229 7.84375 11C7.84375 11.6719 7.6875 12.2448 7.375 12.7188C7.0625 13.1875 6.625 13.5469 6.0625 13.7969C5.5 14.0417 4.84896 14.1641 4.10938 14.1641C3.63021 14.1641 3.15365 14.1016 2.67969 13.9766C2.20573 13.8464 1.77604 13.638 1.39062 13.3516C1.00521 13.0651 0.697917 12.6849 0.46875 12.2109C0.239583 11.7318 0.125 11.1432 0.125 10.4453H2.375C2.375 10.8255 2.42448 11.1432 2.52344 11.3984C2.6224 11.6484 2.7526 11.849 2.91406 12C3.08073 12.1458 3.26823 12.25 3.47656 12.3125C3.6849 12.375 3.89583 12.4062 4.10938 12.4062C4.44271 12.4062 4.71615 12.3464 4.92969 12.2266C5.14844 12.1068 5.3125 11.9427 5.42188 11.7344C5.53646 11.5208 5.59375 11.2812 5.59375 11.0156Z" fill="white"/>
                            </svg>
                        </span>
                        <input v-model="form.price" @wheel.prevent @focus="priceFocused=true" @blur="priceFocused=false" placeholder=" 34.55" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686 pl-6" type="number">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else-if="markupPercent && form.price" class="text-xs capitalize">{{markupType?markupType:'Markup'}}: {{markupPercent}}%</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>

            <div class="w-full xl:w-1/4">
                <div class="input-wrapper relative">
                    <Field v-slot="{field, errors, errorMessage}" name="sale_price" v-model="form.sale_price">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Sale Price:</label>
                        <span class="absolute top-[33px] left-3">
                            <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.88281 0.820312V3.125H3.66406V0.820312H4.88281ZM4.73438 13.5781V15.6797H3.51562V13.5781H4.73438ZM5.59375 11.0156C5.59375 10.7188 5.53906 10.4661 5.42969 10.2578C5.32552 10.0495 5.15365 9.86458 4.91406 9.70312C4.67969 9.54167 4.36198 9.38542 3.96094 9.23438C3.28385 8.97396 2.6875 8.69792 2.17188 8.40625C1.66146 8.10938 1.26302 7.74219 0.976562 7.30469C0.690104 6.86198 0.546875 6.30208 0.546875 5.625C0.546875 4.97917 0.700521 4.41927 1.00781 3.94531C1.3151 3.47135 1.73958 3.10677 2.28125 2.85156C2.82812 2.59115 3.46354 2.46094 4.1875 2.46094C4.73958 2.46094 5.23958 2.54427 5.6875 2.71094C6.13542 2.8724 6.52083 3.11198 6.84375 3.42969C7.16667 3.74219 7.41406 4.125 7.58594 4.57812C7.75781 5.03125 7.84375 5.54948 7.84375 6.13281H5.60156C5.60156 5.82031 5.56771 5.54427 5.5 5.30469C5.43229 5.0651 5.33333 4.86458 5.20312 4.70312C5.07812 4.54167 4.92708 4.42188 4.75 4.34375C4.57292 4.26042 4.3776 4.21875 4.16406 4.21875C3.84635 4.21875 3.58594 4.28125 3.38281 4.40625C3.17969 4.53125 3.03125 4.70052 2.9375 4.91406C2.84896 5.1224 2.80469 5.36198 2.80469 5.63281C2.80469 5.89844 2.85156 6.13021 2.94531 6.32812C3.04427 6.52604 3.21354 6.70833 3.45312 6.875C3.69271 7.03646 4.02083 7.20312 4.4375 7.375C5.11458 7.63542 5.70833 7.91667 6.21875 8.21875C6.72917 8.52083 7.1276 8.89062 7.41406 9.32812C7.70052 9.76562 7.84375 10.3229 7.84375 11C7.84375 11.6719 7.6875 12.2448 7.375 12.7188C7.0625 13.1875 6.625 13.5469 6.0625 13.7969C5.5 14.0417 4.84896 14.1641 4.10938 14.1641C3.63021 14.1641 3.15365 14.1016 2.67969 13.9766C2.20573 13.8464 1.77604 13.638 1.39062 13.3516C1.00521 13.0651 0.697917 12.6849 0.46875 12.2109C0.239583 11.7318 0.125 11.1432 0.125 10.4453H2.375C2.375 10.8255 2.42448 11.1432 2.52344 11.3984C2.6224 11.6484 2.7526 11.849 2.91406 12C3.08073 12.1458 3.26823 12.25 3.47656 12.3125C3.6849 12.375 3.89583 12.4062 4.10938 12.4062C4.44271 12.4062 4.71615 12.3464 4.92969 12.2266C5.14844 12.1068 5.3125 11.9427 5.42188 11.7344C5.53646 11.5208 5.59375 11.2812 5.59375 11.0156Z" fill="white"/>
                            </svg>
                        </span>
                        <input @wheel.prevent v-model="form.sale_price" placeholder="75" class="bg-gray-black border-none rounded text-sm  w-full pl-6 pr-[10px]" type="number">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else>
                            <div v-if="discountPercent()" class="text-xs flex">
                                <p class="mt-1 text-theme-878686">Discount: 
                                    <span class="text-white">{{discountPercent()}}%</span>
                                </p>
                                <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="mt-1 ml-2">
                                    <path d="M6.57812 9.625H7.51562V5.875H6.57812V9.625ZM7 4.71875C7.14583 4.71875 7.26823 4.67188 7.36719 4.57812C7.46615 4.48438 7.51562 4.36458 7.51562 4.21875C7.51562 4.07292 7.46615 3.94792 7.36719 3.84375C7.26823 3.73958 7.14583 3.6875 7 3.6875C6.85417 3.6875 6.73177 3.73958 6.63281 3.84375C6.53385 3.94792 6.48438 4.07292 6.48438 4.21875C6.48438 4.36458 6.53385 4.48438 6.63281 4.57812C6.73177 4.67188 6.85417 4.71875 7 4.71875ZM7 12.75C6.14583 12.75 5.33854 12.5859 4.57812 12.2578C3.81771 11.9297 3.15365 11.4818 2.58594 10.9141C2.01823 10.3464 1.57031 9.68229 1.24219 8.92188C0.914062 8.16146 0.75 7.34896 0.75 6.48438C0.75 5.63021 0.914062 4.82292 1.24219 4.0625C1.57031 3.30208 2.01823 2.64062 2.58594 2.07813C3.15365 1.51563 3.81771 1.07031 4.57812 0.742187C5.33854 0.414062 6.15104 0.25 7.01562 0.25C7.86979 0.25 8.67708 0.414062 9.4375 0.742187C10.1979 1.07031 10.8594 1.51563 11.4219 2.07813C11.9844 2.64062 12.4297 3.30208 12.7578 4.0625C13.0859 4.82292 13.25 5.63542 13.25 6.5C13.25 7.35417 13.0859 8.16146 12.7578 8.92188C12.4297 9.68229 11.9844 10.3464 11.4219 10.9141C10.8594 11.4818 10.1979 11.9297 9.4375 12.2578C8.67708 12.5859 7.86458 12.75 7 12.75ZM7.01562 11.8125C8.48437 11.8125 9.73438 11.2943 10.7656 10.2578C11.7969 9.22135 12.3125 7.96354 12.3125 6.48438C12.3125 5.01563 11.7969 3.76562 10.7656 2.73438C9.73438 1.70312 8.47917 1.1875 7 1.1875C5.53125 1.1875 4.27865 1.70312 3.24219 2.73438C2.20573 3.76562 1.6875 5.02083 1.6875 6.5C1.6875 7.96875 2.20573 9.22135 3.24219 10.2578C4.27865 11.2943 5.53646 11.8125 7.01562 11.8125Z" fill="white"/>
                                </svg>
                            </div>
                            <div v-if="calculateSaleMarkupMargin()" class="text-xs flex">
                                <p class="mt-1 capitalize">Sale {{markupType?markupType:'Markup'}}: 
                                    <span class="text-white">{{calculateSaleMarkupMargin()==='error'?'Error':calculateSaleMarkupMargin()+'%'}}</span>
                                </p>
                            </div>
                        </div>
                    </Field>
                </div>
            </div>

            <div class="w-full xl:w-1/4">
                <div class="input-wrapper relative">
                    <Field v-slot="{field, errors, errorMessage}" name="onlineSalePrice" v-model="form.onlineSalePrice">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">Online Sale Price</label>
                        <span class="absolute top-[33px] left-3">
                            <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.88281 0.820312V3.125H3.66406V0.820312H4.88281ZM4.73438 13.5781V15.6797H3.51562V13.5781H4.73438ZM5.59375 11.0156C5.59375 10.7188 5.53906 10.4661 5.42969 10.2578C5.32552 10.0495 5.15365 9.86458 4.91406 9.70312C4.67969 9.54167 4.36198 9.38542 3.96094 9.23438C3.28385 8.97396 2.6875 8.69792 2.17188 8.40625C1.66146 8.10938 1.26302 7.74219 0.976562 7.30469C0.690104 6.86198 0.546875 6.30208 0.546875 5.625C0.546875 4.97917 0.700521 4.41927 1.00781 3.94531C1.3151 3.47135 1.73958 3.10677 2.28125 2.85156C2.82812 2.59115 3.46354 2.46094 4.1875 2.46094C4.73958 2.46094 5.23958 2.54427 5.6875 2.71094C6.13542 2.8724 6.52083 3.11198 6.84375 3.42969C7.16667 3.74219 7.41406 4.125 7.58594 4.57812C7.75781 5.03125 7.84375 5.54948 7.84375 6.13281H5.60156C5.60156 5.82031 5.56771 5.54427 5.5 5.30469C5.43229 5.0651 5.33333 4.86458 5.20312 4.70312C5.07812 4.54167 4.92708 4.42188 4.75 4.34375C4.57292 4.26042 4.3776 4.21875 4.16406 4.21875C3.84635 4.21875 3.58594 4.28125 3.38281 4.40625C3.17969 4.53125 3.03125 4.70052 2.9375 4.91406C2.84896 5.1224 2.80469 5.36198 2.80469 5.63281C2.80469 5.89844 2.85156 6.13021 2.94531 6.32812C3.04427 6.52604 3.21354 6.70833 3.45312 6.875C3.69271 7.03646 4.02083 7.20312 4.4375 7.375C5.11458 7.63542 5.70833 7.91667 6.21875 8.21875C6.72917 8.52083 7.1276 8.89062 7.41406 9.32812C7.70052 9.76562 7.84375 10.3229 7.84375 11C7.84375 11.6719 7.6875 12.2448 7.375 12.7188C7.0625 13.1875 6.625 13.5469 6.0625 13.7969C5.5 14.0417 4.84896 14.1641 4.10938 14.1641C3.63021 14.1641 3.15365 14.1016 2.67969 13.9766C2.20573 13.8464 1.77604 13.638 1.39062 13.3516C1.00521 13.0651 0.697917 12.6849 0.46875 12.2109C0.239583 11.7318 0.125 11.1432 0.125 10.4453H2.375C2.375 10.8255 2.42448 11.1432 2.52344 11.3984C2.6224 11.6484 2.7526 11.849 2.91406 12C3.08073 12.1458 3.26823 12.25 3.47656 12.3125C3.6849 12.375 3.89583 12.4062 4.10938 12.4062C4.44271 12.4062 4.71615 12.3464 4.92969 12.2266C5.14844 12.1068 5.3125 11.9427 5.42188 11.7344C5.53646 11.5208 5.59375 11.2812 5.59375 11.0156Z" fill="white"/>
                            </svg>
                        </span>
                        <input @wheel.prevent v-model="form.onlineSalePrice" name="onlineSalePrice" placeholder="39.99" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686 pl-6" type="number">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">
                            <div v-if="calculateSaleMarkupMargin('online')" class="text-xs flex">
                                <p class="mt-1 capitalize">Sale {{markupType?markupType:'Markup'}}: 
                                    <span class="text-white">{{calculateSaleMarkupMargin('online')==='error'?'Error':calculateSaleMarkupMargin('online')+'%'}}</span>
                                </p>
                            </div>
                        </div>
                    </Field>
                </div>
            </div>
        </div>
        <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper">
                    <Field v-slot="{field, errors, errorMessage}" name="barcode" v-model="form.barcode">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">GTIN/barcode</label>
                        <input v-model="form.barcode" maxlength="16" placeholder="00043423322" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="text">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                    </Field>
                </div>
            </div>
        </div>
        
        <div class="flex justify-center">
            <button class="rounded bg-theme-green hover:bg-theme-green-300 px-28 py-3 text-sm tracking-wider font-medium">CONTINUE</button>
        </div>
    </Form>
</template>
<script>
import { ref, defineComponent } from 'vue'
import {Form, Field} from 'vee-validate'
import {mapGetters} from 'vuex'
import lowerCase from 'lodash/lowerCase'
import StringHelper from '@/helpers/string'
import ObjectHelper from '@/helpers/object'
import ProductHelper from '@/helpers/product'
import PriceMarkupSettingApis from "@/controllers/LocationMarkupPrice";

export default defineComponent({
    props: ['defaults', 'productForm'],
    components: {
        Form,
        Field
    },
    setup() {
        const form = ref({
            variantName: '',
            dryCannabisEquivalency: '',
            thc_cbd_value_type: 'range',
            cost: '',
            price: '',
            sale_price: '',
            onlineSalePrice: '',
            barcode: ''
        })
        const locationSchema = {
            variantName: 'required',
            dryCannabisEquivalency: 'required|price',
            price: 'required|price',
            cost: 'required|price',
            sale_price: 'price|saleGreaterThanRegular:price',
            onlineSalePrice: 'price|saleGreaterThanRegular:price',
            barcode: 'required'
        }
        const locationAccessorySchema = {
            variantName: 'required',
            price: 'required|price',
            cost: 'required|price',
            sale_price: 'price|saleGreaterThanRegular:price',
            onlineSalePrice: 'price|saleGreaterThanRegular:price',
            barcode: 'required'
        }
        const schema = {
            variantName: 'required',
            dryCannabisEquivalency: 'price'
        }

        const cbdValueTypes = ['single', 'range']
        const markupPrices = ref([])
        

        // for markup
        const priceFocused = ref(false)
        const markupPercent = ref('')
        const markupType = ref('')
        const regularPriceModified = ref(false)

        return {form, locationSchema, locationAccessorySchema, schema, cbdValueTypes, markupPrices, priceFocused, markupPercent, markupType, regularPriceModified}
    },
    async mounted(){
        this.getMarkupPrices()
        this.getRegularPrice()
    },
    computed: {
        ...mapGetters({
            vg_selectedBusiness: 'auth/activeBusiness',
            vg_selectedLocation: 'location/selected'
        })
    },
    watch: {
        defaults(value){
            this.form = ObjectHelper.pickWithDefault(
                value, ['variantName', 'dryCannabisEquivalency', 'thc_cbd_value_type', 'cost', 'sale_price', 'price', 'barcode'],
                ['', '', 'single', '', '', '', '']
            )
        },
        'form.cost'(){
            this.getRegularPrice()
        },
        'productForm.complianceType'() {
            this.getRegularPrice()
        },
        'form.price'(){
            this.regularPriceModified = true
            if(this.priceFocused && this.form.cost){
                this.calculateMarkupPercent()
            }
        }

    },
    methods: {
        getSchema(){
            if(this.vg_selectedLocation.id){
                if(this.productForm.complianceType?.toLowerCase()=='accessory'){
                    return this.locationAccessorySchema
                }else{
                    return this.locationSchema
                }
            }else{
                return this.schema
            }
        },
        calculatePrice(val){
            if(!this.productForm.complianceType) return

            let currentMarkupPrice = this.markupPrices.find(each => each.complianceType?.toLowerCase()===this.productForm.complianceType.replace(/\s/gi, '').replace('-','').toLowerCase())
            if(currentMarkupPrice && currentMarkupPrice.status && currentMarkupPrice.markupPercentage){
                this.markupPercent = currentMarkupPrice.markupPercentage
                this.markupType = currentMarkupPrice.markupType
                let value = parseFloat(val)
                this.currentMarkupPrice = parseInt(currentMarkupPrice.markupPercentage)
                let result = 0
                let decimal = 0
                if(currentMarkupPrice.markupType==='margin'){
                    let marginVal = 1-this.currentMarkupPrice/100
                    result = parseFloat(value)/marginVal
                    return result?result.toFixed(2):''
                }else{
                    result = parseFloat(value)+(val*this.currentMarkupPrice/100)
                    decimal = (result%1).toFixed(2)
                    if(decimal>0){
                        return result?+parseInt(result)+0.99:''
                    }else{
                        return result?+result.toFixed(2):''
                    }
                }
            }
        },
        calculateMarkupPercent(){
            if(this.markupType==='margin'){
                this.markupPercent = ((this.form.price-this.form.cost)/(this.form.price*0.01)).toFixed(2)
            }else{
                this.markupPercent = ((this.form.price-this.form.cost)/(this.form.cost*0.01)).toFixed(2)
            }
        },
        async getMarkupPrices(){
            let res = await PriceMarkupSettingApis.fetchByLocationId(this.vg_selectedLocation.id)
            if(res.status==200){
                this.markupPrices = res.data.payload
            }
        },
        getRegularPrice(){
            let price = this.calculatePrice(this.form.cost)
            this.form.price = price?price:this.defaults.cost
            this.calculateMarkupPercent()
        },
        labelClass(value, error){
            if(value && error){
                return 'text-theme-red'
            }else if(error){
                return 'text-theme-orange'
            }else if(value){
                return 'text-theme-green'
            }
        },
        inputClass(value, error){
            if(value && error){
                return 'border-theme-red'
            }else if(error){
                return 'border-theme-orange'
            }else if(value){
                return 'border-theme-green'
            }
        },
        errorClass(value, error){
            if(value && error){
                return 'text-theme-red'
            }else if(error){
                return 'text-theme-orange'
            }
        },
        calculateSaleMarkupMargin(type='sale'){
            if(!this.productForm.complianceType) return
            let currentMarkupPrice = this.markupPrices.find(each => each.complianceType?.toLowerCase()===lowerCase(this.productForm.complianceType.replace(/\s/gi, '')))
            let salePrice = type==='sale'?this.form.sale_price:this.form.onlineSalePrice
            let result
            if(currentMarkupPrice){
                result =  ProductHelper.saleMarginMarkup(salePrice, this.form.cost, currentMarkupPrice.markupType)
            }else{
                result =  ProductHelper.saleMarginMarkup(salePrice, this.form.cost, 'markup')
            }
            return result
        },
        discountPercent(){
            if(this.form.sale_price && this.form.price){
                return StringHelper.roundOff((this.form.price-this.form.sale_price)/this.form.price*100)
            }else{
                return ''
            }
        },
        submit(){
            this.$emit('validated', this.form)
        },
    }
})
</script>
